module.exports = __webpack_public_path__ + "img/usdoicon.ad6db306.png";